<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 60px; top: 118px">
      <p>Busca el título del poema y señálalo.</p>
    </span>

    <div id="radio0">
      <label class="toggleButtonContainer pageElement" id="toggle01"
        >EL ZAPATO GLO GLO GLO
        <input type="radio" name="nombreLibro" value="1" @change="toggleSelect(1)" ref="t1">
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle02"
        >EL SAPITO CLO CLO CLO
        <input type="radio" name="nombreLibro" value="2" @change="toggleSelect(2)" ref="t2">
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle03"
        >EL SAPITO GLO GLO GLO
        <input type="radio" name="nombreLibro" value="3" @change="toggleSelect(3)" ref="t3">
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle04"
        >EL SAPO GLO GLO GLO
        <input type="radio" name="nombreLibro" value="4" @change="toggleSelect(4)" ref="t4">
        <span class="toggleButton"></span>
      </label>
    </div>

    <img id="clouds" class="pageElement slideItem" src="/pages/img/sordoglo/svgGlo23Clouds.svg" />
    <img id="pond" class="pageElement" src="/pages/img/sordoglo/svgGlo23Pond.svg" />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 38.89px;
  top: 19px;
}

#clouds{
  position: absolute;
  left: 544px;
  top: 19px;
}
#pond{
  position: absolute;
  left: 35px;
  top: 507px;
}

#toggle01 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 260px;
  top: 225px;
}
#toggle02 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 260px;
  top: 300px;
}
#toggle03 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 260px;
  top: 373px;
}
#toggle04 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 260px;
  top: 447px;
}
</style>
<script>
export default {
  data() {
		return {
			videos: ["glo/Video 110.mp4"]
		};
	},
computed: {
    dbId(){
        return `${this.$parent.pageID()}-nombreLibro`
    },          
},
methods:{
    toggleSelect(option){
		this.$db.options.put({
                    id: this.dbId,
                    option: option
                }).catch(function(error){
                    console.log("error saving option" + error);
                });
		console.log(this.dbId);
		console.log(option);
	}
},
async created() {
	var value = await this.$db.options.get({
	id: this.dbId,
	}).catch(function(error){
	console.log("error getting option" + error);
	});
	if (value === undefined) return;
	console.log("loaded value");
	console.log(value);

	if (value.option === 1){
	this.$refs.t1.checked = true;
	}
	else if (value.option === 2)
	{
	this.$refs.t2.checked = true;
	}
	else if (value.option === 3) {
	this.$refs.t3.checked = true;
	}
	else {
	this.$refs.t4.checked = true;
	}
	},
}
</script>